import { IJSONObject } from "@blings/blings-player";
import { AccountFontInput } from "../../../API";

import { FontInput } from "../../../API";
import { weight2Name } from "../../../utils/font";
import { ExtractedValues } from "../../../utils/getTypesFromLiveControl";
import { FontFamily } from "../../../utils/font";

// ─── Helper functions ─────────────────────────────
export function fontInVideo2NestedFontFamily(
  fonts: Array<FontInput>
): Array<FontFamily> {
  const fontFamilies = new Map<string, Array<FontFamily["variants"][number]>>();
  fonts.forEach((font) => {
    if (fontFamilies.has(font.family)) {
      fontFamilies
        .get(font.family)
        ?.push({ ...font, name: weight2Name[font.weight as string] });
    } else {
      fontFamilies.set(font.family, [
        {
          ...font,
          name: weight2Name[font.weight as string],
          weight: font.weight,
        },
      ]);
    }
  });
  return Array.from(fontFamilies).map(([fontFamily, variants]) => ({
    fontFamily,
    variants,
  }));
}

export function getVariantsFromFontFamily(
  selectedFontFamily: string,
  fontFamilies: Array<FontFamily>
): AccountFontInput["variants"] {
  if (!fontFamilies) return [];
  const found = fontFamilies.find(
    (fontFamily) => fontFamily.fontFamily === selectedFontFamily
  );
  // @ts-ignore
  return found ? found.variants : [];
}
export function toTitleCase(text: string) {
  return text
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}
export function extractFontsFromAccount(
  fontsFromAccount: Array<AccountFontInput>
): Array<AccountFontInput> {
  const fonts: Array<AccountFontInput> = JSON.parse(
    JSON.stringify(fontsFromAccount || [])
  );
  const fontsWithVariants: Array<AccountFontInput> = [];
  for (let index = 0; index < fonts.length; index++) {
    const font = fonts[index];
    font.variants = font.variants.filter((variant) => variant.url);
    if (font.variants.length) {
      fontsWithVariants.push(font);
    }
  }
  return JSON.parse(JSON.stringify(fontsWithVariants));
}

export const getTypesFromLiveControlSchema = (
  scheme: IJSONObject
): ExtractedValues => {
  const result: ExtractedValues = {
    texts: [],
    images: [],
    colors: [],
    numbers: [],
    dates: [],
    audio: [],
    videos: [],
    booleans: [],
    links: [],
  };

  if (!scheme) {
    return result;
  }

  const results = Object.keys(scheme).reduce<ExtractedValues>(
    (acc: ExtractedValues, key: string) => {
      const type = (scheme[key] as IJSONObject)?.["type"] as string;
      const format = (scheme[key] as IJSONObject)?.["format"] as string;
      if (format) {
        if (format === "image") {
          acc.images.push(key);
        } else if (format === "color") {
          acc.colors.push(key);
        } else if (format === "text") {
          acc.texts.push(key);
        } else if (format === "link") {
          acc.links.push(key);
        } else if (format === "number") {
          acc.numbers.push(key);
        } else if (format === "date") {
          acc.dates.push(key);
        } else if (format === "boolean") {
          acc.booleans.push(key);
        } else if (format === "audio") {
          acc.audio.push(key);
        } else if (format === "video") {
          acc.videos.push(key);
        }
      } else {
        if (type === "string") {
          acc.texts.push(key);
        } else if (type === "number") {
          acc.numbers.push(key);
        }
      }

      return acc;
    },
    result
  );

  return results;
};
